import MedAireSecurityAPIService from '../services/api/MedAireSecurity/ApiService'
import MapBox from './../modules/map'
import { FIR_LAYERS_FEATURE_COLLECTION } from './../data/fir-layers'
import { DetailsPanel } from '../components/DetailsPanel/DetailsPanel'
import { AirspacePopupComponent } from '../components/AirspacePopup/AirspacePopup'
import AvsecAlerts from './avsecAlerts'
import moment from 'moment'

export class AeroSpaceModule {
  warningAndRestrictions = []
  affectedFIRsWithHighestFlightRestrictionLevel = null
  airports = []
  FIRFeatureCollection = null
  selectedFIRID = null
  aviationAlerts = []
  hasInitialized = false

  initialize(airports) {
    this.airports = airports
    this.getAirspaceWarningsAndRestrictions()
    this.getAlertsAndFlightRestrictionData()
    this.startLatestAlertsObserver()
  }


  getAlertsAndFlightRestrictionData() {
    Promise.all([this.getModuleWarningsAndRestrictions(), AvsecAlerts.getModuleLatestAlerts()]).then(([restrictions, aviationAlerts]) => {
      let affectedFIRsWithHighestFlightRestrictionLevel = {}
      restrictions.forEach(restriction => {
        let affectedFIRsArray = restriction.affectedFIRs.split(', ')
        affectedFIRsArray.forEach(affectedFIRCode => {
          if (affectedFIRsWithHighestFlightRestrictionLevel[affectedFIRCode] === undefined) {
            affectedFIRsWithHighestFlightRestrictionLevel[affectedFIRCode] = restriction.flightLevel
          }
          if (restriction.flightLevel > affectedFIRsWithHighestFlightRestrictionLevel[affectedFIRCode]) {
            affectedFIRsWithHighestFlightRestrictionLevel[affectedFIRCode] = restriction.flightLevel
          }
        })
      })

      this.affectedFIRsWithHighestFlightRestrictionLevel = affectedFIRsWithHighestFlightRestrictionLevel
      this.aviationAlerts = aviationAlerts.filter(res => {
        let isLive = moment(res.Date).isSameOrAfter(moment().subtract(24, 'hours')) ? true : false
        if (res?.AffectedFIRs?.length > 0 && isLive) {
          return true
        }
      })

      // Need to figure out what will be the best way to pass this information to the layers which is ~8MB of data
      // As for now let's take the simpliest approach and include it in the GEOJSON object before displaying and see 
      // if this approach is good or if there is another better way
      const updatedFeatures = FIR_LAYERS_FEATURE_COLLECTION.features.map(FIRFeature => {
        if (this.affectedFIRsWithHighestFlightRestrictionLevel[FIRFeature.properties.ICAOCODE] !== undefined) {
          FIRFeature.properties.highestRestrictionLevel = this.affectedFIRsWithHighestFlightRestrictionLevel[FIRFeature.properties.ICAOCODE]
        }

        FIRFeature.properties.anyAviationAlertsIssued = this.aviationAlerts.some(alert => alert.AffectedFIRs?.includes(FIRFeature.properties.ICAOCODE))

        return FIRFeature
      })

      this.FIRFeatureCollection = {
        ...FIR_LAYERS_FEATURE_COLLECTION,
        features: updatedFeatures
      }

      this.displayFIRLayers()
      this.initializeEventListeners()

      this.hasInitialized = true
    })
  }

  startLatestAlertsObserver() {
    const ONE_MINUTE = 1000 * 60
    window.setInterval(() => {
      this.getAlertsAndFlightRestrictionData()
    }, ONE_MINUTE)
  }

  getAirspaceWarningsAndRestrictions() {
    MedAireSecurityAPIService.getRestrictions().then(restrictions => {
      const updatedWarningsAndRestrictions = restrictions?.map(restriction => {
        const a = this.airports.find(airport => airport.Isocode3 === restriction.issuingCountryCode)
        restriction.issuingCountryName = (a && !!a.Country) ? a.Country : 'Unknown'

        if (restriction.issuingCountryCode === 'EUE') {
          restriction.issuingCountryName = 'European Union'
        } else if (restriction.issuingCountryCode === 'PRK') {
          restriction.issuingCountryName = 'North Korea'
        } else if (restriction.issuingCountryCode === 'USA') {
          restriction.issuingCountryName = 'United States of America'
        }

        restriction.displayIssueDate = ''
        if (restriction.issueDate !== '') {
          restriction.displayIssueDate = moment(restriction.issueDate).format('YYYY-MM-DD')
        }

        restriction.displayExpirationDate = ''
        if (restriction.expirationDate !== '') {
          restriction.displayExpirationDate = moment(restriction.expirationDate).format('YYYY-MM-DD')
        }

        return restriction
      })

      this.warningAndRestrictions = updatedWarningsAndRestrictions
    })
  }

  async getModuleWarningsAndRestrictions() {
    const warningAndRestrictions = await new Promise((resolve) => {
      const observerInterval = window.setInterval(() => {
        if (this.warningAndRestrictions.length > 0) {
          resolve(this.warningAndRestrictions)
          window.clearInterval(observerInterval)
        }
      }, 25)
    })

    return warningAndRestrictions
  }

  async subscribeToModuleInitialization() {
    const hasInitialized = await new Promise((resolve) => {
      const observerInterval = window.setInterval(() => {
        if (this.hasInitialized) {
          resolve(true)
          window.clearInterval(observerInterval)
        }
      }, 25)
    })

    return hasInitialized
  }

  displayFIRLayers() {
    const alertLayer = MapBox.map.getSource('fir')

    if (alertLayer !== undefined) {
      alertLayer.setData(this.FIRFeatureCollection)
    } else {
      MapBox.map.addSource('fir', {
        'type': 'geojson',
        'data': this.FIRFeatureCollection
      })

      MapBox.map.addLayer({
        id: 'fir-flight-restriction',
        type: 'fill',
        source: 'fir',
        layout: {
          visibility: 'none' // Default value
        },
        paint: {
          'fill-color':
            [
              'match',
              ['get', 'highestRestrictionLevel'],
              1, '#90C388',
              2, '#D3B446',
              3, '#F0682B',
              4, '#F22F2F',
              5, '#741106',
              '#5FE9D0'
            ]

          // [
          //   'case',
          //   ['==', ['feature-state', 'flight-restriction-level'], 1], '#A4B77E',
          //   ['==', ['feature-state', 'flight-restriction-level'], 2], '#D39546',
          //   ['==', ['feature-state', 'flight-restriction-level'], 3], '#F0682B',
          //   ['==', ['feature-state', 'flight-restriction-level'], 4], '#F22F2F',
          //   ['==', ['feature-state', 'flight-restriction-level'], 5], '#CA1D09',
          //   '#5FE9D0'
          // ]
          ,
          'fill-opacity': [
            'match',
            ['get', 'highestRestrictionLevel'],
            1, 0.4,
            2, 0.4,
            3, 0.4,
            4, 0.4,
            5, 0.4,
            0
          ]
        }
      })

      MapBox.map.addLayer({
        'id': 'fir-outline',
        'type': 'line',
        'source': 'fir',
        'layout': {
          visibility: 'none' // Default value
        },
        'paint': {
          'line-color': '#5FE9D0',
          'line-width': [
            'case',
            ['boolean', ['feature-state', 'selected'], false], 5,
            ['boolean', ['feature-state', 'hover'], false], 1,
            0.5
          ]
        }
      })

      // Add a red color border if the FIR has any aviation alerts issued
      MapBox.map.addLayer({
        id: 'fir-aviation-alert',
        type: 'line',
        source: 'fir',
        layout: {
          visibility: 'none' // Default value
        },
        paint: {
          'line-color': '#D44333',
          'line-width': [
            'case',
            ['boolean', ['get', 'anyAviationAlertsIssued'], false], 2,
            0
          ]
        }
      })

      MapBox.map.addLayer({
        id: 'fir-aviation-alert-line-dashed',
        type: 'line',
        source: 'fir',
        layout: {
          visibility: 'none' // Default value
        },
        paint: {
          'line-color': '#a1e7da', // #FFEB3B
          'line-width': [
            'case',
            ['boolean', ['get', 'anyAviationAlertsIssued'], false], 2,
            0
          ],
          'line-dasharray': [0, 4, 3]
        }
      })

      MapBox.map.addLayer({
        id: 'fir-fill',
        type: 'fill',
        source: 'fir',
        layout: {
          visibility: 'none' // Default value
        },
        paint: {
          'fill-color': '#5FE9D0',
          'fill-opacity': [
            'case',
            ['boolean', ['feature-state', 'hover'], false], 0.1,
            ['boolean', ['feature-state', 'selected'], false], 0.15,
            0
          ]
        }
      })

      // technique based on https://jsfiddle.net/2mws8y3q/
      // an array of valid line-dasharray values, specifying the lengths of the alternating dashes and gaps that form the dash pattern
      const dashArraySequence = [
        [0, 4, 3],
        [0.5, 4, 2.5],
        [1, 4, 2],
        [1.5, 4, 1.5],
        [2, 4, 1],
        [2.5, 4, 0.5],
        [3, 4, 0],
        [0, 0.5, 3, 3.5],
        [0, 1, 3, 3],
        [0, 1.5, 3, 2.5],
        [0, 2, 3, 2],
        [0, 2.5, 3, 1.5],
        [0, 3, 3, 1],
        [0, 3.5, 3, 0.5]
      ]

      let step = 0

      function animateDashArray(timestamp) {
        // Update line-dasharray using the next value in dashArraySequence. The
        // divisor in the expression `timestamp / 50` controls the animation speed.
        const newStep = parseInt((timestamp / 100) % dashArraySequence.length)

        if (newStep !== step) {
          MapBox.map.setPaintProperty('fir-aviation-alert-line-dashed', 'line-dasharray', dashArraySequence[step])
          step = newStep
        }
        // Request the next frame of the animation.
        requestAnimationFrame(animateDashArray)
      }

      // start the animation
      animateDashArray(0)
    }
  }

  clearFIRSelection() {
    MapBox.map.easeTo({
      padding: { 'right': 0 }
    })

    this.clearFIRSelectedState()

    this.selectedFIRID = false
  }

  clearFIRSelectedState() {
    MapBox.map.setFeatureState(
      { source: 'fir', id: this.selectedFIRID },
      { selected: false }
    )
  }

  showFIRLayers() {
    MapBox.map.setLayoutProperty('fir-fill', 'visibility', 'visible')
    MapBox.map.setLayoutProperty('fir-outline', 'visibility', 'visible')
    MapBox.map.setLayoutProperty('fir-aviation-alert', 'visibility', 'visible')
    MapBox.map.setLayoutProperty('fir-aviation-alert-line-dashed', 'visibility', 'visible')
    MapBox.map.setLayoutProperty('fir-flight-restriction', 'visibility', 'visible')
    document.getElementsByClassName('app-template')[0].classList.add('fir-enabled')
  }

  hideFIRLayers() {
    MapBox.map.setLayoutProperty('fir-fill', 'visibility', 'none')
    MapBox.map.setLayoutProperty('fir-outline', 'visibility', 'none')
    MapBox.map.setLayoutProperty('fir-aviation-alert', 'visibility', 'none')
    MapBox.map.setLayoutProperty('fir-aviation-alert-line-dashed', 'visibility', 'none')
    MapBox.map.setLayoutProperty('fir-flight-restriction', 'visibility', 'none')
    document.getElementsByClassName('app-template')[0].classList.remove('fir-enabled')
  }

  selectFIR(code, controllingCountryCode, FIRName, countries, centlong = null, centlat = null, selectedFIRFeatureID = null, region = '', nameComponent = '') {
    this.clearFIRSelectedState()

    DetailsPanel.showFlightInformationRegionDetails(code, controllingCountryCode, FIRName, countries)

    // This function can be called only by providing a basic data, in that case we need to find additional information
    if (centlong === null || centlat === null || selectedFIRFeatureID === null) {
      let airspaceFeature = null
      if (region && nameComponent) {
        airspaceFeature = FIR_LAYERS_FEATURE_COLLECTION.features.find(airspaceFeature => airspaceFeature.properties.ICAOCODE === code && airspaceFeature.properties.REGION === region && airspaceFeature.properties.NOM_COMP === nameComponent)
      } else {
        airspaceFeature = FIR_LAYERS_FEATURE_COLLECTION.features.find(airspaceFeature => airspaceFeature.properties.ICAOCODE === code)
      }

      if (airspaceFeature === undefined) {
        window.alert('Could not found FIR with code: ' + code + ' on the map.')
        return
      } else {
        centlong = airspaceFeature.properties.centlong
        centlat = airspaceFeature.properties.centlat
        selectedFIRFeatureID = airspaceFeature.id
      }
    }

    MapBox.map.easeTo({
      padding: {
        // Would there be a better way to understand the width of that component, or is this the best way?
        'right': document.querySelector('#vue-details-panel .details-panel').getClientRects()[0].width
      },
      center: [centlong, centlat],
      // zoom: 4 // Could improve, as this zoom level doesn't work well for very big/small FIR layers, maybe could depend on the square size of the layer? 
    })

    this.selectedFIRID = selectedFIRFeatureID
    MapBox.map.setFeatureState(
      { source: 'fir', id: this.selectedFIRID },
      { selected: true, 'flight-restriction-level': 3 }
    )
  }

  hideFIRPopup() {
    AirspacePopupComponent.$data.display = 'none'
    AirspacePopupComponent.$data.name = ''
    AirspacePopupComponent.$data.code = ''
    AirspacePopupComponent.$data.highestRestrictionLevel = 0
  }

  initializeEventListeners() {
    let hoveredFIRId = null

    MapBox.map.on('mousemove', 'fir-fill', (e) => {
      if (e.features.length > 0) {
        if (hoveredFIRId !== null) {
          MapBox.map.setFeatureState(
            { source: 'fir', id: hoveredFIRId },
            { hover: false }
          )
        }

        hoveredFIRId = e.features[0].id
        MapBox.map.setFeatureState(
          { source: 'fir', id: hoveredFIRId },
          { hover: true }
        )
      }

      var airspaceData = e.features[0].properties
      if (airspaceData.highestRestrictionLevel !== undefined) {
        AirspacePopupComponent.$data.display = 'block'
        AirspacePopupComponent.$data.name = airspaceData.FIR_NAME
        AirspacePopupComponent.$data.code = airspaceData.ICAOCODE
        AirspacePopupComponent.$data.highestRestrictionLevel = airspaceData.highestRestrictionLevel

        MapBox.map.getCanvas().style.cursor = 'pointer'

        AirspacePopupComponent.$data.leftPosition = e.point.x + 15 + 'px'
        AirspacePopupComponent.$data.topPosition = e.point.y + 15 + 'px'
      } else {
        this.hideFIRPopup()
      }
    })

    // When the mouse leaves the state-fill layer, update the feature state of the
    // previously hovered feature.
    MapBox.map.on('mouseleave', 'fir-fill', () => {
      if (hoveredFIRId !== null) {
        MapBox.map.setFeatureState(
          { source: 'fir', id: hoveredFIRId },
          { hover: false }
        )
      }

      hoveredFIRId = null

      this.hideFIRPopup()
    })
  }
}

const AeroSpace = new AeroSpaceModule()
export default AeroSpace